import { render } from "./DocPreview.vue?vue&type=template&id=06441d3f&ts=true"
import script from "./DocPreview.vue?vue&type=script&lang=ts"
export * from "./DocPreview.vue?vue&type=script&lang=ts"

import "./DocPreview.vue?vue&type=style&index=0&id=06441d3f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__